/* global angular */

export default function SubsectionsPanelController(
  editSectionDialog,
  loaderService,
  pmSharedModelService,
  ssDialogService,
) {
  const vm = this;
  vm.handleEdit = _handleEdit;

  /** **************************************************
   * Event Handlers
   */

  function _handleEdit($event, subsection) {
    loaderService.showViewLoader = true;
    return pmSharedModelService.getSection(subsection.policyDocumentSectionId)
      .then((section) => {
        loaderService.showViewLoader = false;
        angular.extend(subsection, section);
        return _showEditSectionDialog($event, {
          policyDocumentId: vm.policyDocumentId,
          permissions: vm.permissions,
          section: subsection
        });
      });
  }

  /** **************************************************
   * Private Functions
   */

  function _showEditSectionDialog($event, locals) {
    const dialogId = `editSectionDialog${locals.section.policyDocumentSectionId}`;
    ssDialogService.dialogs.pm[dialogId] = ssDialogService.alert(
      editSectionDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.pm[dialogId]);
  }
}

SubsectionsPanelController.$inject = [
  'editSectionDialog',
  'loaderService',
  'pmSharedModelService',
  'ssDialogService',
];
